<template>
  <v-menu bottom left>
    <template #activator="{ on, attrs }">
      <v-btn v-bind="attrs"
             :color="color"
             :outlined="outline"
             depressed
             :large="large"
             :icon="!label"
             v-on="on"
             @click.stop>
        {{ label }}
        <v-icon :small="!defaultSize">
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <template v-for="(option, index) in options">
        <v-list-item v-if="option.visible" 
                     :key="option.id || index"
                     :disabled="option.disabled"
                     @click.stop="onClick(option)">
          <v-list-item-icon v-if="option.icon">
            <v-icon :color="option.color">{{ option.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title :class="option.color ? `${option.color}--text` : ''">{{ option.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { slugify } from '~utils/utils'
export default {
  name: 'DynamicMenu',
  props: {
    icon: {
      type: String,
      default: 'mdi-dots-vertical'
    },
    color: {
      type: String,
      default: 'default'
    },
    label: {
      type: String,
      default: ''
    },
    outline: {
      type: Boolean,
      default: false
    },
    defaultSize: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onClick(option) {
      this.$emit(option.id || slugify(option.title))
    }
  }
}
</script>
